#import "../fragments/audience-fragment.graphql"

query GetAudience($audienceId: ID!) {
    audience(id: $audienceId) {
        ...Audience
    }
}
